import React,{useContext} from "react";
import { Row,Badge } from "react-bootstrap";
import { Link, NavLink } from "react-router-dom";
import back from "../../components/assets/bx_bx-arrow-back.png";
import "./Dashboard.css";
import Logo from "../../components/assets/logo long.svg";
import iHome from "../../components/assets/_home.png";
import iTrade from "../../components/assets/_trade.png";
// import userImg from "../../components/assets/user.png";
import iHistory from "../../components/assets/_history.png";
import iAgents from "../../components/assets/_agent.png";
import iSettings from "../../components/assets/_settings.png";
import BTCRate from "../../components/BTCRate"
import Cookies from "js-cookie"
import {UserContext} from "../UserContext"

const Dashboard = (props) => {
  const user = useContext(UserContext)
  const [copySuccess,setCopySuccess] = React.useState("")
  const handleLogOut = ()=>{
    Cookies.remove("auth")
    user.setUser("")
     props.history.push("/")
   }
   const copyToClipboard = () => {
    var textField = document.createElement('textarea')
    textField.innerText = `https://bitmasta.io/register/ref=${user.userDetails.code}`
    document.body.appendChild(textField)
    textField.select()
    document.execCommand('copy')
    textField.remove()
    setCopySuccess('Copied!');
    };
  return (
    <div className="container">
      <Row className="d-flex mb-sm-0 justify-content-between bts-db-header">
        <div className="">
          <Link to="/">
            <img src={Logo} alt="Bitmasta" />
          </Link>
        </div>
        <div className="d-none d-md-block">
        <BTCRate/>

        </div>
        <div>  
          <span to="tel:+2348162898892" onClick={handleLogOut} className="blueText cursor b7 medText plain">
            Log out
          </span>
        </div>
      </Row>
      <div className="d-flex justify-content-center d-md-none">
          <BTCRate/>
      </div>
      <div className="mt-5 row mx-0 pt-sm-2">
        <div className="col-md-2 mx-0 mb-sm-3 mb-3 col-sm-12">
          <span className="blueText cursor" onClick={props.back}>
            <img src={back} alt="" className="blueText" />
            Back
          </span> 
        </div>
        <div className="col-md-8 col-sm-12">
          {/* <div className="d-flex justify-content-between referral-banner"> */}
        {user.userDetails &&  <div className="row text-center referral-banner">
            <div className="col-12"> 
                <p className="m-0 font-weight-bold">Share your referral link with your friends and Win N10k for 10 successful Transactions <span role="img" aria-label="">🎉</span></p>
            </div>
            <div onClick={copyToClipboard} className="bold col-12">
             {user.userDetails? `https://bitmasta.io/register/ref=${user.userDetails.code}` :null}
            <Badge variant="success">{copySuccess}</Badge>
            </div>
          </div>}
          <p className="b7 medText blueText mt-2">You are welcome</p>

          <div className="bts-db-options-wrapper">
            <NavLink to="/dashboard" activeClassName="current">
              <div className="bts-db-options text-center">
                <img src={iHome} alt="" />
                <div className="b7 blueText">Home</div>
              </div>
            </NavLink>

            <NavLink to="/trade" activeClassName="current" className="line">
              <div className="bts-db-options text-center">
                <img src={iTrade} alt="" />
                <div className="b7 blueText">Trade</div>
              </div>
            </NavLink>

            <NavLink to="/history" activeClassName="current" className="line">
              <div className="bts-db-options text-center">
                <img src={iHistory} alt="" />
                <div className="b7 blueText">History</div>
              </div>
            </NavLink>

            <NavLink to="/referrals" activeClassName="current" className="line">
              <div className="bts-db-options text-center">
                <img src={iAgents} alt="" />
                <div className="b7 blueText">Referral</div>
              </div>
            </NavLink>

            <NavLink to="/settings" activeClassName="current" className="line">
              <div className="bts-db-options text-center">
                <img src={iSettings} alt="" />
                <div className="b7 blueText">Settings</div>
              </div>
            </NavLink>
          </div>
          <div className="pt-4">{props.children}</div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
